<ul>
  @for(category of categories; track category){
    <li>
      <a href="javascript:void(0)" [routerLink]="['/collections']" [queryParams]="{ category: category?.slug }" class="text-content">{{ category.name }}</a>
    </li>
  }
</ul>
